import {
  Blend,
  Bucket,
  Category2,
  Element4,
  EmojiSad,
  HierarchySquare,
  Key,
  Link1,
  Link21,
  MenuBoard,
  ShoppingCart,
  SmsTracking,
  User,
  Box,
  Tag2,
  ArchiveBox,
  Receipt,
  ClipboardText,
  ReceiptEdit,
  Setting2
} from "iconsax-react";

const listItems = [
  {
    head: "Manage Links",
    link: "/",
    icon: <Link1 />,
  },
  {
    head: "Bad feedback",
    link: "/badfeedback",
    icon: <EmojiSad />,
  },

];

export { listItems };
